var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.namespace)?_c('i',{staticClass:"weui-icon fit-icon",class:_vm.iconClass,attrs:{"aria-hidden":"true"}}):_c('i',{class:`${_vm.namespace}-icon ${_vm.prefix}-${_vm.icon} fit-icon`,attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }